export interface ChecklistPhaseDefaults {
  auditPhase: 'Phase 1' | 'Phase 2';
  phase2Required: boolean;
}

/**
 * New checklist rows should follow the active CSAudit phase.
 * Any P2 status means the added PAWs are Phase 2 work items and must count toward P2 completion.
 */
export function deriveChecklistPhaseDefaults(phaseStatus?: string | null): ChecklistPhaseDefaults {
  const normalized = String(phaseStatus ?? '').trim().toLowerCase();
  const isPhase2 =
    normalized.startsWith('phase 2') ||
    normalized.startsWith('p2') ||
    normalized.includes('phase 2 -') ||
    normalized.includes('p2 -');

  if (isPhase2) {
    return {
      auditPhase: 'Phase 2',
      phase2Required: true,
    };
  }

  return {
    auditPhase: 'Phase 1',
    phase2Required: false,
  };
}
